module.exports = __webpack_public_path__ + "static/img/name5.2176341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cn/name5.png
// module id = 1ykC
// module chunks = 1